(ns core.authorization.oidc.model
  (:require [cloudpermit-commons.schemas.general :as general]
            [core.domain.schemas :as schemas]
            [schema-tools.core :as st]
            [schema.core :as s]))


(s/defschema ID
  (s/constrained s/Str #(re-matches #"[\w-]+" %) "ID must consist of letters, numbers and dashes."))


(def secret-fields #{:oidc-config/client-secret})


(s/defschema OIDCConfigKeys
  (st/merge {:oidc-config/id                    ID
             :oidc-config/display-name          general/NonBlankString
             :oidc-config/client-id             general/NonBlankString
             :oidc-config/profile-scope?        s/Bool
             :oidc-config/skip-iss-validation?  s/Bool
             :oidc-config/check-email-verified? s/Bool}
            (st/optional-keys {:oidc-config/client-secret          general/NonBlankString
                               :oidc-config/issuer                 general/NonBlankString
                               :oidc-config/authorization-endpoint schemas/URI
                               :oidc-config/token-endpoint         schemas/URI
                               :oidc-config/jwks-uri               schemas/URI
                               :oidc-config/revocation-endpoint    schemas/URI
                               :oidc-config/userinfo-endpoint      schemas/URI
                               :oidc-config/discovery-uri          schemas/URI
                               :oidc-config/domain-groups          #{s/Int}
                               :oidc-config/public-login?          s/Bool
                               :db/id                              (s/cond-pre s/Int s/Str)})))


(s/defschema OIDCDiscoveryConfigEdit
  (st/required-keys OIDCConfigKeys [:oidc-config/discovery-uri]))


(s/defschema OIDCDiscoveryConfig
  (st/required-keys OIDCDiscoveryConfigEdit [:oidc-config/client-secret]))


(s/defschema OIDCManualConfigEdit
  (st/required-keys OIDCConfigKeys [:oidc-config/issuer
                                    :oidc-config/authorization-endpoint
                                    :oidc-config/token-endpoint
                                    :oidc-config/jwks-uri]))


(s/defschema OIDCManualConfig
  (st/required-keys OIDCManualConfigEdit [:oidc-config/client-secret]))


(s/defschema OIDCAnyConfig
  (s/conditional (every-pred :db/id :oidc-config/discovery-uri) OIDCDiscoveryConfigEdit
                 :oidc-config/discovery-uri OIDCDiscoveryConfig
                 :db/id OIDCManualConfigEdit
                 :else OIDCManualConfig))
